import React from 'react'
import styles from './index.module.less'
import { Autoplay } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
const url = 'https://hyhzimfg-1316759422.cos.ap-shanghai.myqcloud.com/assets'
export default function Partners() {

  return (
    <>
      <div className={styles.array}>
        <Swiper
          loop
          slidesPerView={1}
          modules={[Autoplay]}
          autoplay={{ delay: 2000, stopOnLastSlide: false, disableOnInteraction: false }}>
          <SwiperSlide>
            <img src={url + '/imgs/partner_swiper1.png'} alt="" />
          </SwiperSlide>
          <SwiperSlide>
            <img src={url + '/imgs/partner_swiper2.png'} alt="" />
          </SwiperSlide>
        </Swiper>
        {/* <img src='https://hyhzgw-1316759422.cos.ap-shanghai.myqcloud.com/assets/logox50-26.png' alt="" />
        <img src='https://hyhzgw-1316759422.cos.ap-shanghai.myqcloud.com/assets/logox50-27.png' alt="" />
        <img src='https://hyhzgw-1316759422.cos.ap-shanghai.myqcloud.com/assets/logox50-28.png' alt="" />
        <img src='https://hyhzgw-1316759422.cos.ap-shanghai.myqcloud.com/assets/logox50-29.png' alt="" />
        <img src='https://hyhzgw-1316759422.cos.ap-shanghai.myqcloud.com/assets/logox50-30.png' alt="" />
        <img src='https://hyhzgw-1316759422.cos.ap-shanghai.myqcloud.com/assets/logox50-31.png' alt="" />
        <img src='https://hyhzgw-1316759422.cos.ap-shanghai.myqcloud.com/assets/logox50-32.png' alt="" />
        <img src='https://hyhzgw-1316759422.cos.ap-shanghai.myqcloud.com/assets/logox50-33.png' alt="" />
        <img src='https://hyhzgw-1316759422.cos.ap-shanghai.myqcloud.com/assets/logox50-34.png' alt="" />
        <img src='https://hyhzgw-1316759422.cos.ap-shanghai.myqcloud.com/assets/logox50-35.png' alt="" />
        <img src='https://hyhzgw-1316759422.cos.ap-shanghai.myqcloud.com/assets/logox50-36.png' alt="" />
        <img src='https://hyhzgw-1316759422.cos.ap-shanghai.myqcloud.com/assets/logox50-37.png' alt="" />
        <img src='https://hyhzgw-1316759422.cos.ap-shanghai.myqcloud.com/assets/logox50-38.png' alt="" />
        <img src='https://hyhzgw-1316759422.cos.ap-shanghai.myqcloud.com/assets/logox50-39.png' alt="" />
        <img src='https://hyhzgw-1316759422.cos.ap-shanghai.myqcloud.com/assets/logox50-40.png' alt="" />
        <img src='https://hyhzgw-1316759422.cos.ap-shanghai.myqcloud.com/assets/logox50-41.png' alt="" />
        <img src='https://hyhzgw-1316759422.cos.ap-shanghai.myqcloud.com/assets/logox50-42.png' alt="" />
        <img src='https://hyhzgw-1316759422.cos.ap-shanghai.myqcloud.com/assets/logox50-43.png' alt="" />
        <img src='https://hyhzgw-1316759422.cos.ap-shanghai.myqcloud.com/assets/logox50-44.png' alt="" />
        <img src='https://hyhzgw-1316759422.cos.ap-shanghai.myqcloud.com/assets/logox50-45.png' alt="" />
        <img src='https://hyhzgw-1316759422.cos.ap-shanghai.myqcloud.com/assets/logox50-46.png' alt="" />
        <img src='https://hyhzgw-1316759422.cos.ap-shanghai.myqcloud.com/assets/logox50-47.png' alt="" />
        <img src='https://hyhzgw-1316759422.cos.ap-shanghai.myqcloud.com/assets/logox50-48.png' alt="" />
        <img src='https://hyhzgw-1316759422.cos.ap-shanghai.myqcloud.com/assets/logox50-49.png' alt="" />
        <img src='https://hyhzgw-1316759422.cos.ap-shanghai.myqcloud.com/assets/logox50-50.png' alt="" /> */}
      </div>
    </>
  )
}
